import { selectUserGeolocation } from '../../selectors/user.selectors'
import { env } from '../../../utils'

const getGeolocationParam = state => {
  const isGeolocationActive = env('REACT_APP_GEOLOCATION') === 'active'
  const { lat, lng } = selectUserGeolocation(state)
  const geolocationParam = isGeolocationActive ? { ll: [lat, lng].join(',') } : {}
  return geolocationParam
}

export default getGeolocationParam
